import type { GovernanceQuerySchema } from '../schemas';

export const fieldNames: Record<keyof GovernanceQuerySchema, { name: string; revertible: boolean }> = {
  id: { name: 'ID', revertible: false },
  jurisdiction: { name: 'Jurisdiction', revertible: true },
  registration_number: { name: 'Registration Number', revertible: true },
  registered_agent_name: { name: 'Registered Agent Name', revertible: true },
  registered_agent_addresses: { name: 'Registered Agent Address', revertible: true },
  notes: { name: 'Notes', revertible: true },
  supporting_documentation: { name: 'Supporting Documentation', revertible: false },
  legal_business_name: { name: 'Legal Business Name', revertible: true },
};
